<template>
  <div class="drawer">
    <div class="drawer-container">
      <el-tabs v-model="activeName" @tab-click="handleClickTab">
        <el-tab-pane :label="$t('menu.bargains')" name="detail">
          <div class="drawer-content with-tab">
            <el-form
              ref="orderForm"
              :model="order"
              class="box"
              label-width="80px"
            >
              <fieldset class="mgb15">
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('order.serialNo')">
                      <span v-if="order.hurry" class="red">
                        ({{ $t("order.hurrySimple") }})
                      </span>
                      <s v-if="order.retrieveAt != null">
                        {{ order.serialNo }}
                      </s>
                      <span v-if="order.retrieveAt == null">
                        <s
                          v-if="order.jyOrderCancelAt != null"
                          class="color-grey"
                          >{{ order.serialNo }}</s
                        >
                        <span v-if="order.jyOrderCancelAt == null">{{
                          order.serialNo
                        }}</span>
                      </span>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('workOrder.serialNo')">
                      {{ order.workOrderSn }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.innerSerialNo')">
                      {{ order.innerSerialNo }}
                    </el-form-item>
                  </el-col>
                </el-row>

                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('text.workflowState')">
                      <state-label :state="order.workflowState">
                        {{ $t("mesOrderStates." + order.workflowState) }}
                      </state-label>
                    </el-form-item>
                  </el-col>

                  <el-col :span="8">
                    <el-form-item :label="$t('text.handOverAt')">
                      {{ order.handOverAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.createAt')">
                      {{ order.createAt }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('menu.factories')">
                      {{ order.factoryName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.handler')">
                      {{ order.ownerName }}/{{ order.handleDepart }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('menu.customers')">
                      {{ order.customerName }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col v-if="order.pauseAt != null" :span="8">
                    <el-form-item :label="$t('order.pauseAt')">
                      {{ order.pauseAt }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset class="mgb15">
                <legend>
                  {{ $t("order.productInfo") }}
                  <a
                    v-if="order.attachment"
                    class="fr blue"
                    target="_blank"
                    :href="order.attachment"
                  >
                    {{ $t("action.downloadAttatchment") }}
                  </a>
                </legend>

                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('product.productNo')">
                      {{ order.productNo }}
                      <small
                        v-if="
                          order.customerProductNo != null &&
                          order.customerProductNo != ''
                        "
                      >
                        ({{ order.customerProductNo }})
                      </small>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.category')">
                      {{ order.categoryName }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.brand')">
                      {{ order.productBrand }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row :gutter="10">
                  <el-col :span="8">
                    <el-form-item :label="$t('product.color')">
                      <span class="float-left mgr5">{{ order.color }}</span>
                      <thumbnail
                        class="mgt5"
                        v-if="order.colorImage != null"
                        :images="order.colorImage"
                        width="25"
                        height="25"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('product.size')">
                      {{ order.size }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item :label="$t('text.quantity')">
                      {{ order.quantity }} {{ order.unit }}
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row v-if="Permit.canActions('globalCostPrice')">
                  <el-col :span="8">
                    <el-form-item :label="$t('orderMes.price')">
                      {{ order.costPrice }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
              <fieldset
                v-if="
                  order.specJson != null &&
                  order.specJson != '' &&
                  JSON.parse(order.specJson).length != 0
                "
                class="mgb15"
              >
                <legend>{{ $t("product.specJson") }}</legend>
                <el-tag
                  v-for="s in JSON.parse(order.specJson)"
                  :key="s.name"
                  type="info"
                  >{{ s.name }}：{{ s.value }}</el-tag
                >
              </fieldset>
              <fieldset v-if="order.images != null" class="mgb15">
                <legend>{{ $t("product.images") }}</legend>
                <thumbnail :images="order.images" list></thumbnail>
              </fieldset>
              <fieldset
                v-if="order.craftwork != null && order.craftwork != ''"
                class="mgb15"
              >
                <legend>{{ $t("product.craftwork") }}</legend>
                <raw-html :content="order.craftwork" type="richText" />
              </fieldset>
              <fieldset
                v-if="order.remark != null && order.remark != ''"
                class="mgb15"
              >
                <legend>{{ $t("text.remark") }}</legend>
                <raw-html :content="order.remark" type="richText" />
              </fieldset>
              <fieldset v-if="order.cancelAt" class="mgb15">
                <legend>{{ $t("order.cancel") }}</legend>
                <el-row>
                  <el-col :span="8">
                    <el-form-item :label="$t('order.cancelAt')">
                      {{ order.cancelAt }}
                    </el-form-item>
                  </el-col>
                  <el-col :span="16">
                    <el-form-item :label="$t('order.cancelReason')">
                      {{ order.cancelReason }}
                    </el-form-item>
                  </el-col>
                </el-row>
              </fieldset>
            </el-form>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('menu.phases')" name="phase">
          <div class="drawer-content with-tab-footer">
            <vxe-table
              :data="phasePlans"
              size="mini"
              resizable
              round
              auto-resize
              highlight-hover-row
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                width="60px"
                v-if="
                  Permit.canActionsChargeEdition('mesOrderPhasesManage') &&
                  order &&
                  ['dispatched', 'processing'].includes(order.workflowState)
                "
              >
                <template v-slot="{ row, rowIndex }">
                  <i
                    v-if="rowIndex != 0"
                    class="el-icon-top mgr10"
                    @click="swapSequence(row, rowIndex, 'up')"
                  ></i>
                  <i
                    v-if="rowIndex + 1 != phasePlans.length"
                    class="el-icon-bottom"
                    @click="swapSequence(row, rowIndex, 'down')"
                  ></i>
                </template>
              </vxe-table-column>
              <vxe-table-column field="phaseName" :title="$t('menu.phases')" />
              <vxe-table-column
                field="phaseHour"
                :title="$t('phaseTemplate.phaseHour')"
                min-width="80px"
              />
              <vxe-table-column
                field="phasePrice"
                :title="$t('factory.phasePrice')"
                min-width="80px"
              >
                <template v-slot="{ row }">
                  {{ row.phasePrice | currency }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="period"
                :title="$t('phaseTemplate.period')"
                min-width="70px"
              />
              <vxe-table-column
                field="inspect"
                :title="$t('phaseTemplate.inspect')"
                min-width="60px"
              >
                <template v-slot="{ row }">
                  {{ $t("boolean." + row.inspect) }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="print"
                :title="$t('action.print')"
                min-width="50px"
              >
                <template v-slot="{ row }">
                  {{ $t("boolean." + row.print) }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="planEndAt"
                :title="$t('order.planEndAt')"
                min-width="110px"
              />
              <vxe-table-column
                v-if="
                  Permit.canActionsChargeEdition('mesOrderPhasesManage') &&
                  order &&
                  ['newly', 'dispatched', 'processing'].includes(
                    order.workflowState
                  )
                "
                field="action"
                :title="$t('text.action')"
                width="100px"
              >
                <template v-slot="{ row }">
                  <el-button
                    type="text"
                    size="mini"
                    @click="editPhasePlan(row)"
                    >{{ $t("text.edit") }}</el-button
                  >
                  <el-button
                    type="text"
                    size="mini"
                    @click="deletePhasePlan(row)"
                    >{{ $t("text.delete") }}</el-button
                  >
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('menu.workOrders')" name="workOrder">
          <div class="drawer-content with-tab">
            <vxe-table
              :data="workOrders"
              size="mini"
              resizable
              round
              auto-resize
              highlight-hover-row
              :scroll-y="{ enabled: false }"
            >
              <vxe-table-column
                field="images"
                :title="$t('product.images')"
                width="85"
              >
                <template v-slot="{ row }">
                  <thumbnail :images="row.images"></thumbnail>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="serialNo"
                :title="$t('text.serialNo')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.serialNo }}
                  <div>
                    <state-label :state="row.workflowState">
                      {{ $t("workOrderStates." + row.workflowState) }}
                    </state-label>
                  </div>
                </template>
              </vxe-table-column>

              <vxe-table-column
                field="productNo"
                :title="$t('product.productNo')"
                min-width="100"
              >
                <template v-slot="{ row }">
                  {{ row.productNo }}
                  <div class="font10">
                    {{ row.category }}
                    <span v-if="row.productBrand != null">/</span>
                    {{ row.productBrand }}
                  </div>
                  <div class="font10">{{ row.color }} {{ row.size }}</div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="quantity"
                :title="$t('text.quantity')"
                min-width="60"
              >
                <template v-slot="{ row }">
                  {{ row.quantity }}{{ row.unit }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="handOverAt"
                :title="$t('text.handOverAt')"
                width="110"
              >
                <template v-slot="{ row }">
                  {{ row.handOverAt }}
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="handler"
                :title="$t('text.handle')"
                min-width="110"
              >
                <template v-slot="{ row }">
                  {{ row.handler }}
                  <div class="font10">{{ row.handleDepart }}</div>
                </template>
              </vxe-table-column>
              <vxe-table-column
                field="remark"
                :title="$t('text.remark')"
                min-width="80"
              >
                <template v-slot="{ row }">
                  <raw-html-limit-number
                    :content="row.remark"
                    :number="8"
                    type="richText"
                  />
                </template>
              </vxe-table-column>
            </vxe-table>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('text.log')" name="log">
          <div class="drawer-content with-tab">
            <div class="box">
              <el-timeline>
                <el-timeline-item
                  v-for="(log, index) in logs"
                  :key="index"
                  :timestamp="log.doAt"
                >
                  <span v-if="log.doBy != null" style="color: #909399">{{
                    log.doBy
                  }}</span>
                  <raw-html :content="log.content"></raw-html>
                </el-timeline-item>
              </el-timeline>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane
          :label="$t('menu.relateProcures')"
          name="procure"
          v-if="Permit.extendModels().includes('mms')"
        >
          <vxe-table
            :data="procures"
            ref="recordsTable"
            class="recordsTable"
            size="mini"
            resizable
            round
            auto-resize
            highlight-hover-row
            :scroll-y="{ enabled: false }"
          >
            <vxe-table-column
              field="serialNo"
              :title="$t('procure.serialNo')"
              min-width="140"
            >
              <template v-slot="{ row }">
                {{ row.serialNo }}
                <div>
                  <state-label :state="row.workflowState">
                    {{ $t("procureTypes." + row.workflowState) }}
                  </state-label>
                </div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="firstSupplierName"
              :title="$t('menu.suppliers')"
              min-width="80"
            />
            <vxe-table-column
              field="handOverAt"
              :title="$t('text.handOverAt')"
              min-width="100"
            />
            <vxe-table-column
              field="verifyAt"
              :title="$t('procure.verifyAt')"
              min-width="80"
            >
              <template v-slot="{ row }">
                {{ row.verifyName }}
                <div class="font10">{{ row.verifyAt }}</div>
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="placeAt"
              :title="$t('procure.placeAt')"
              min-width="80"
            >
              <template v-slot="{ row }">
                {{ row.buyerName }}
                <div class="font10">{{ row.placeAt }}</div>
              </template>
            </vxe-table-column>

            <vxe-table-column
              field="finishAt"
              :title="$t('procure.finishAt')"
              min-width="100"
            />

            <vxe-table-column
              field="remark"
              :title="$t('text.remark')"
              min-width="100"
            >
              <template v-slot="{ row }">
                <raw-html-limit-number
                  :content="row.remark"
                  :number="6"
                  type="richText"
                />
              </template>
            </vxe-table-column>
            <vxe-table-column
              field="createAt"
              :title="$t('text.createAt')"
              min-width="80"
            >
              <template v-slot="{ row }">
                {{ row.ownerName }}
                <div class="font10">{{ row.createdAt }}</div>
              </template>
            </vxe-table-column>
          </vxe-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <div v-if="activeName == 'phase'" class="drawer-footer">
      <el-button
        v-if="
          Permit.canActionsChargeEdition('mesOrderPhasesManage') &&
          order &&
          ['dispatched', 'processing'].includes(order.workflowState)
        "
        type="primary"
        size="small"
        @click="addPhasePlan"
      >
        + {{ $t("menu.phases") }}
      </el-button>
      <el-button
        v-if="Permit.canActions('mesProductDistributePhases')"
        type="defalut"
        plain
        size="small"
        @click="asyncPhaseToPdm"
        >{{ $t("action.asyncPhaseToPdm") }}</el-button
      >
    </div>
    <!-- 新增工序 -->
    <el-dialog
      :append-to-body="true"
      :title="$t('rules.create', [$t('menu.phases')])"
      :close-on-click-modal="false"
      :visible.sync="addPhasePlanDF"
      width="30%"
    >
      <el-form
        ref="addPhasePlanForm"
        :model="addPhasePlanObj"
        label-width="110px"
      >
        <el-form-item
          :label="$t('menu.phases')"
          :prop="'phaseId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('menu.phases')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select size="small" v-model="addPhasePlanObj.phaseId" filterable>
            <el-option
              v-for="phase in filterPhases"
              :key="phase.id"
              :label="phase.name"
              :value="phase.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('phaseTemplate.phaseHour')"
          :prop="'phaseHour'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('phaseTemplate.phaseHour')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="addPhasePlanObj.phaseHour" />
        </el-form-item>
        <el-form-item
          :label="$t('phaseTemplate.period')"
          :prop="'period'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('phaseTemplate.period')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model.trim="addPhasePlanObj.period" />
        </el-form-item>
        <el-form-item :label="$t('phaseTemplate.inspect')" :prop="'inspect'">
          <el-checkbox size="small" v-model="addPhasePlanObj.inspect" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="addPhasePlanDoing"
          size="small"
          @click="addPhasePlanSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="addPhasePlanDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :append-to-body="true"
      :title="$t('rules.edit', [$t('menu.phases')])"
      :close-on-click-modal="false"
      :visible.sync="editPhasePlanDF"
      width="30%"
    >
      <div class="red center mgb10">
        注意：修改后，跟此订单关联的工单工序也会修改
      </div>
      <el-form
        ref="editPhasePlanForm"
        :model="editPhasePlanObj"
        label-width="110px"
      >
        <el-form-item
          :label="$t('phaseTemplate.phaseHour')"
          :prop="'phaseHour'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('phaseTemplate.phaseHour')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model="editPhasePlanObj.phaseHour" />
        </el-form-item>
        <el-form-item
          :label="$t('phaseTemplate.period')"
          :prop="'period'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('phaseTemplate.period')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-input size="small" v-model="editPhasePlanObj.period" />
        </el-form-item>
        <el-form-item :label="$t('phaseTemplate.inspect')" :prop="'inspect'">
          <el-checkbox size="small" v-model="editPhasePlanObj.inspect" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="editPhasePlantDoing"
          size="small"
          @click="editPhasePlanSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="editPhasePlanDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { page } from "@/utils/mixins.js";
import Util from "@/utils";
import RawHtml from "@/components/RawHtml";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import Order from "@/api/order.js";
import OrderMes from "@/api/orderMes.js";
import Log from "@/api/log.js";
import WorkOrder from "@/api/workOrder.js";
import Phase from "@/api/phase.js";
import Procure from "@/api/procure.js";

export default {
  props: {
    uuid: String,
    id: Number,
  },
  mixins: [page],
  components: {
    RawHtml,
    RawHtmlLimitNumber,
  },
  data() {
    return {
      activeName: "detail",
      order: { workflowState: "newly" },
      logs: [],
      phasePlans: [],
      workOrders: [],
      procures: [],
      //
      // 新增工序
      phases: [],
      filterPhases: [],
      addPhasePlanDF: false,
      addPhasePlanObj: {
        orderUuid: null,
        phaseId: null,
        phaseName: null,
        phasePrice: null,
        phaseHour: null,
        period: null,
        inspect: null,
      },
      addPhasePlanDoing: false,
      // 编辑工序
      editPhasePlanDF: false,
      row: null,
      editPhasePlanObj: {
        phaseHour: null,
        period: null,
        inspect: null,
      },
      editPhasePlantDoing: false,
    };
  },
  created() {
    const self = this;
    self.handleClickTab();
  },
  methods: {
    asyncPhaseToPdm() {
      const self = this;
      OrderMes.asyncPhaseToPdm(self.id).then(function (res) {
        if (res.status == 200) {
          self.sysResult(res.data);
        } else {
          self.sysError();
        }
      });
    },
    swapSequence(row, rowIndex, type) {
      const self = this;
      const obj = {
        swapId: row.id,
        swapId2:
          type == "up"
            ? self.phasePlans[rowIndex - 1].id
            : self.phasePlans[rowIndex + 1].id,
      };
      OrderMes.phasePlanSwapSequence(obj).then(function (res) {
        if (res.status == 200) {
          self.sysResult(res.data);
          self.getPhasePlans();
        } else {
          self.sysError();
        }
      });
    },
    // 删除
    deletePhasePlan(row) {
      const self = this;
      OrderMes.phaseMakesFindByPhasePlanId(row.id, {
        phasePlanId: row.id,
        orderUuid: self.order.uuid,
      }).then(function (res) {
        if (res.data.length === 0) {
          if (confirm("删除后,跟此订单关联的工单工序也会删除,确认删除?")) {
            OrderMes.phasePlanDelete(row.id).then(function (res) {
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.delSuccess"),
                  type: "success",
                });
                self.getPhasePlans();
              } else {
                self.sysError();
              }
            });
          }
        } else {
          self.$message({
            message: self.$t("prompt.phaseHasBeenProcess"),
            type: "warning",
          });
        }
      });
    },
    // 编辑工序
    editPhasePlan(row) {
      const self = this;
      self.row = row;
      self.editPhasePlanObj.phaseHour = row.phaseHour;
      self.editPhasePlanObj.period = row.period;
      self.editPhasePlanObj.inspect = row.inspect;
      self.editPhasePlantDoing = false;
      OrderMes.phaseMakesFindByPhasePlanId(row.id, {
        phasePlanId: row.id,
        orderUuid: self.order.uuid,
      }).then(function (res) {
        if (res.data.length === 0) {
          self.editPhasePlanDF = true;
        } else {
          self.$message({
            message: self.$t("prompt.phaseHasBeenProcess"),
            type: "warning",
          });
        }
      });
    },

    editPhasePlanSubmit() {
      const self = this;
      self.$refs.editPhasePlanForm.validate((valid) => {
        if (valid) {
          if (!Util.regexQuantity(self.editPhasePlanObj.phaseHour)) {
            self.$message({
              message: self.$t("rules.regex", [
                self.$t("phaseTemplate.phaseHour"),
              ]),
              type: "warning",
            });
            return;
          }
          if (!Util.regexQuantity(self.editPhasePlanObj.period)) {
            self.$message({
              message: self.$t("rules.regex", [
                self.$t("phaseTemplate.period"),
              ]),
              type: "warning",
            });
            return;
          }
          self.editPhasePlantDoing = true;
          OrderMes.phasePlanUpdate(self.row.id, self.editPhasePlanObj).then(
            function (res) {
              if (res.status === 200) {
                self.$message({
                  message: self.$t("prompt.editSuccess"),
                  type: "success",
                });
                self.editPhasePlantDoing = false;
                self.editPhasePlanDF = false;
                self.getPhasePlans();
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },
    // 新增工序
    addPhasePlan() {
      const self = this;
      self.addPhasePlanObj.orderUuid = self.order.uuid;
      self.addPhasePlanObj.phaseId = null;
      self.addPhasePlanObj.phaseName = null;
      self.addPhasePlanObj.phasePrice = null;
      self.addPhasePlanObj.phaseHour = null;
      self.addPhasePlanObj.period = null;
      self.addPhasePlanObj.inspect = false;
      self.addPhasePlanDoing = false;
      Phase.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.phases = res.data;
          self.filterPhases = self.phases.filter(
            (p) => self.phasePlans.find((pp) => pp.phaseId == p.id) == null
          );
          self.addPhasePlanDF = true;
        } else {
          self.sysError();
        }
      });
    },
    addPhasePlanSubmit() {
      const self = this;
      self.$refs.addPhasePlanForm.validate((valid) => {
        if (valid) {
          self.addPhasePlanObj.phaseName = self.phases.find(
            (p) => p.id === self.addPhasePlanObj.phaseId
          ).name;
          if (!Util.regexQuantity(self.addPhasePlanObj.phaseHour)) {
            self.$message({
              message: self.$t("rules.regex", [
                self.$t("phaseTemplate.phaseHour"),
              ]),
              type: "warning",
            });
            return;
          }
          if (!Util.regexQuantity(self.addPhasePlanObj.period)) {
            self.$message({
              message: self.$t("rules.regex", [
                self.$t("phaseTemplate.period"),
              ]),
              type: "warning",
            });
            return;
          }
          self.addPhasePlanDoing = true;
          OrderMes.phasePlansCreate([self.addPhasePlanObj]).then(function (
            res
          ) {
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.addPhasePlanDoing = false;
              self.addPhasePlanDF = false;
              self.getPhasePlans();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    //=====================
    handleClickTab(tab, event) {
      if (this.activeName == "detail") {
        this.getOrder();
      }
      if (this.activeName == "phase") {
        this.getPhasePlans();
      }
      if (this.activeName == "workOrder") {
        this.getWorkOrders();
      }
      if (this.activeName == "log") {
        this.getLogs();
      }
      if (this.activeName == "procure") {
        this.getProcures();
      }
    },
    getProcures() {
      const self = this;
      Procure.findByOrderUuid(self.order.uuid).then(function (res) {
        if (res.status === 200) {
          self.procures = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getOrder() {
      const self = this;
      self.loadingStart();
      OrderMes.findByUuid({ uuid: self.uuid }).then(function (res) {
        if (res.data.code === 200) {
          self.order = res.data.entity;
        } else {
          self.sysError();
        }
        self.loadingEnd();
      });
    },
    getPhasePlans() {
      const self = this;
      OrderMes.phasePlansByOrderUuid({ orderUuid: self.uuid }).then(function (
        res
      ) {
        if (res.status === 200) {
          self.phasePlans = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getWorkOrders() {
      const self = this;
      WorkOrder.findByOrderUuid({ orderUuid: self.uuid }).then(function (res) {
        if (res.status === 200) {
          self.workOrders = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getLogs() {
      const self = this;
      Log.forEntityMes("Order", self.id).then(function (res) {
        self.logs = res.data;
      });
    },
  },
};
</script>